import type { SvgIconComponent } from "@mui/icons-material";
import type { SxProps, Theme } from "@mui/material";
import { Stack, Typography } from "@mui/material";
import DataErrorDialogIcon from "../icons/DataErrorDialogIcon";

interface Props {
  title?: string;
  text?: string;
  sx?: SxProps<Theme>;
  Icon?: SvgIconComponent;
}

const DataLoadingFailed = ({ text, title, sx, Icon }: Props) => {
  return (
    <Stack
      spacing={2}
      sx={[{ alignItems: "center", justifyContent: "center", flex: 1 }, ...(Array.isArray(sx) ? sx : [sx])]}
    >
      {Icon ? <Icon sx={{ width: 80, height: 80 }} /> : <DataErrorDialogIcon sx={{ width: 80, height: 80 }} />}
      <Stack spacing={1} sx={{ alignItems: "center", justifyContent: "center" }}>
        <Typography variant="h6">{title || "Issue loading the data"}</Typography>
        <Typography sx={{ textAlign: "center" }}>
          {text ?? "Oops! I'm sorry, we ran into an unexpected issue... Can you please try refreshing the page?"}
        </Typography>
      </Stack>
    </Stack>
  );
};

export default DataLoadingFailed;
